<template>
  <div class="ui-loader">
    <div class="ui-loader__line" />
    <div class="ui-loader__line" />
    <div class="ui-loader__line" />
  </div>
</template>

<script>
export default {
  name: 'DotLoader',
}
</script>

<style lang="scss">
$prefix: 'ui-loader';

.#{$prefix} {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: center;
}

.#{$prefix}__line {
  background-color: currentColor;
  animation: pulse 1s infinite;
  overflow: hidden;
  border-radius: 50%;
  margin-left: 0.02rem;
  margin-right: 0.02rem;
  width: 0.08rem;
  height: 0.08rem;

  &:first-child {
    animation-delay: 0.1s;
  }

  &:nth-child(2) {
    animation-delay: 0.2s;
  }

  &:nth-child(3) {
    animation-delay: 0.3s;
  }
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.5);
    opacity: 0.75;
  }
  100% {
    transform: scale(1);
  }
}
</style>
